import * as types from "./actionTypes";
import initialState from "reducers/initialState";
import { OFFER_PARTNER_SALARY_DATA_UPDATED } from "features/offer/edit/client/income/eventTypes";

export default function monthlyObligationsReducer(
  state = initialState.currentOffer.clientMonthlyObligationsData,
  action
) {
  switch (action.type) {
    case types.LOAD_PARTNER_MONTHLY_OBLIGATIONS_SUCCEEDED: {
      const { partnerMonthlyObligations } = action.payload;
      const partnerId = partnerMonthlyObligations.partnerId;
      const monthlyObligations = {
        ...state.monthlyObligations,
        [partnerId]: {
          partnerId,
          isLoaded: true
        }
      };

      return {
        ...state,
        monthlyObligations
      };
    }

    case OFFER_PARTNER_SALARY_DATA_UPDATED: {
      const { partnerId } = action.event.eventBody;
      const monthlyObligations = {
        ...state.monthlyObligations,
        [partnerId]: {
          ...state.monthlyObligations[partnerId],
          partnerId,
          isLoaded: false
        }
      };

      return {
        ...state,
        monthlyObligations
      };
    }

    default:
      return state;
  }
}
